export default __webpack_public_path__ + "static/media/slot2.2a4d3aae.png";